import type { PropsWithChildren } from "react";
import * as styles from "./DownloadLink.css";
import type { Props } from "./types";

export default function DowloadLink({
	href,
	type,
	children,
	className,
}: PropsWithChildren<Props>) {
	return (
		<a href={href} className={`${styles.link({ type })} ${className}`}>
			<span>{children}</span>
		</a>
	);
}
